export default __webpack_public_path__ + "static/media/轮播首图8.c89b1950.jpg";